export default __webpack_public_path__ + "static/media/game_dev.b9e48ddf.png";